import React from 'react';
import styles from "./Banner.module.css";
import DOMPurify from "dompurify";
import get from "lodash/get";
import TrackingTickIcon from "./tick-icon";
import WarningIcon from "../WarningIcon";

import {Button, Typography} from "@nzpost/react-components";
import {useIsMobile} from "../useBreakpoints";


export default ({notification, position = 'absolute', additionalStyle = "", onClose = null}) => {

  const isMobile = useIsMobile();
  const msg = get(notification, 'msg');
  const code = get(notification, 'code');

  let bannerStyle;
  let bannerIcon;
  switch (code) {
    case "WARNING":
      bannerStyle = styles.bannerOrange;
      bannerIcon = (
        <div className={styles.warningIcon}>
          <WarningIcon/>
        </div>
      );
      break;
    case "ERROR":
      bannerStyle = styles.bannerRed;
      bannerIcon = (
        <div className={styles.warningIcon}>
          <WarningIcon/>
        </div>
        );
      break;
    case "SUCCESS":
      bannerStyle = styles.banner;
      bannerIcon = (
        <div className={styles.tickIcon}>
          <TrackingTickIcon/>
        </div>
      );
      break;
    default:
      bannerStyle = styles.banner;
      break;
  }

  return (
    <div style={{position}} className={`${bannerStyle} ${additionalStyle} ${!isMobile ? styles.desktopBanner : ""}`} id={"notification-banner"}>
      <div className={styles.bannerInnerLayout}>
        <div className={styles.iconText}>
          {bannerIcon}
          <div id="notification-banner-content" className={styles.bannerContent} >
            <Typography variant="body1">
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(msg, {
                  ALLOWED_TAGS: ['span', 'br'],
                  ALLOWED_ATTR: ['style']
                })
              }}
          /></Typography>
            </div>
        </div>
        {!isMobile && position === 'absolute' && <Button className={styles.bannerClose} onClick={onClose}>Got it</Button>}
      </div>
      {isMobile && 
        <div className={styles.mobileButtonWrapper}>
        { position === 'absolute' && <Button className={styles.bannerClose} onClick={onClose}>Got it</Button>}
        </div>}
    </div>
  );

};